<div cdkDropListGroup class="flex gap-4 overflow-x-auto h-full mt-2 pb-4">
  @for (column of columns(); track column.statusId) {
    <div
      [style.borderTopColor]="column.color"
      [style]="{backgroundColor: column.bgColor}"
      class="kanban-column shrink-0 w-1/5 flex flex-col rounded-2xl border border-slate-100 border-t-[3px] shadow-sm overflow-hidden h-full"
    >
      <div class="flex items-center gap-2 py-3 px-4 shrink-0">
        <elcia-dot [color]="column.color"/>
        <span class="text-sm font-semibold flex-1 truncate text-slate-700">{{ column.title }}</span>
        <span
          class="text-xs font-medium text-slate-600 bg-white/70 ring-1 ring-slate-200 rounded-full py-0.5 px-2 shrink-0">{{ column.todos.length }}</span>
      </div>

      <div
        (cdkDropListDropped)="onDrop($event)"
        [cdkDropListData]="column.todos"
        [id]="'' + column.statusId"
        cdkDropList
        class="flex-1 overflow-y-auto p-2 flex flex-col gap-2 min-h-16"
      >
        @for (todo of column.todos; track todo.id) {
          <elcia-todo-kanban-card
            (onChildCompletionChange)="onChildCompletionChange.emit($event)"
            (onCompletionChange)="onCompletionChange.emit($event)"
            (onEdit)="editTodo($event)"
            [cdkDragData]="todo"
            [highlightChildId]="highlightChildId()"
            [highlighted]="todo.id === highlightTodoId()"
            [todo]="todo"
            cdkDrag
          />
        }

      </div>

      <div class="shrink-0 p-2 pt-0">
        <elcia-button (onClick)="addTodo(column.statusId)" [icon]="'plus'" [size]="'small'"
                      [variant]="'text'"
        />
      </div>
    </div>
  }
</div>
